import { WebHealthMarkerService } from './web';
export default WebHealthMarkerService;
